import { ArrowUp } from "lucide-react";
import { BrandLogo } from "./ui";
export function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-top">
          <a className="wordmark" href="#home" aria-label="QuantumCode home">
            <BrandLogo />
          </a>
          <p>
            Software consulting and development
            <br />
            for web apps and custom business platforms.
          </p>
          <nav aria-label="Footer navigation">
            <a href="#why-us">Why us</a>
            <a href="#process">Our process</a>
            <a href="#contact">Contact</a>
          </nav>
          <a href="#home" className="back-top" aria-label="Back to top">
            <ArrowUp size={19} />
          </a>
        </div>
        <div className="footer-bottom">
          <span>
            © {new Date().getFullYear()} QuantumCode Corp. All rights reserved.
          </span>
          <span>TORONTO, ONTARIO</span>
          <span>BN: 722900610</span>
        </div>
      </div>
    </footer>
  );
}
